import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PricingPage } from '@/features/billing/pricing/pricing-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * « Tarifs » (ADR 0089) : la grille à la minute (SaaS) ou de refacturation interne (self-hosted) et la calculatrice.
 * Tout membre du locataire : `GET /prices`, `GET /instance-types` et `POST /estimations` n'exigent aucun droit.
 */
export const Route = createFileRoute('/$tenant/billing/pricing')({ component: PricingRoute });

function PricingRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="pricing" crumbs={[{ label: t('nav.items.pricing') }]}>
      <PricingPage tenantId={tenant} />
    </ConsoleShell>
  );
}
